// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__a62C1","info":"Footer_info__iYhms"};